import React from 'react';

const Content = () => {
  return (
<div>
  <section className="text-gray-700 bg-gray-300">
    <div className="container px-5 py-24 mx-auto">
      <div className="text-center mb-20">
        <h1 className="sm:text-3xl text-2xl font-medium text-center title-font text-gray-800 mb-4">
          Frequently Asked Question
        </h1>
      </div>
      <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
        <div className="w-full lg:w-1/2 px-4 py-2">
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Apakah ada syarat-syarat yang harus dipenuhi untuk mendaftarkan anak di Sekolah Megana? 
</summary>
<span className="p-5">
    Tidak ada syarat khusus bagi calon murid yang ingin mendaftarkan diri di Sekolah Megana. Namun ada standar penilaian untuk meyakinkan kami bahwa calon siswa memang mampu mengikuti standar pengajaran Kurikulum Kemdikbud untuk mendapatkan ijazah setara SMA. Selain itu, perlu komitmen dari calon siswa dan orangtuanya siap bekerja sama sehingga target untuk bisa mendapatkan nilai IELTS, HSK, dan Ujian Standar Internasional (A Level/SAT/ACT/IB) sebagai syarat penerimaan beasiswa tercapai.
</span>
          </details>
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Berapa jumlah anak di dalam satu kelas? 
</summary>
<span className="p-5">
    Sekolah Megana bersistem hybrid, ada sistem kelas dan private mentoring (1 mentor mengajar 1 siswa) untuk pembelajaran setara SMA sesuai Kurikulum Kemdikbud. SementaraPengajaran IELTS, HSK, dan Ujian Standar Internasional (A Level/SAT/ACT/IB) sesuai perhitungan biaya dan standar kelas yang nyaman. Pertimbangan kami adalah kenyamanan dan konsentrasi siswa dalam belajar sehingga tercapai target secara efektif dan dalam suasana yang menyenangkan. 
</span>
          </details>
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Apakah anak saya dapat bersekolah di Sekolah Megana meskipun sudah mengikuti sekolah konvensional? Bagaimana teknisnya? 
</summary>
<span className="p-5">
    Sekolah Megana dapat dijadikan sebagai sekolah tambahan bagi murid yang sudah bersekolah di tempat lain. Mengapa? Karena pembelajaran di Sekolah Megana khusus Kurikulum Kemdikbud selaras dengan pembelajaran yang juga diadakan di sekolah formal / konvensional. Berdasarkan pengalaman orang tua murid yang mendukung double school,  Sekolah Megana dapat menjadi tambahan, pelengkap, dan solusi menghadapi kondisi sekolah formal konvensional baik nasional, nasional plus, bahkan sekolah internasional,  yang belum siap beradaptasi dengan pembelajaran online di situasi pandemi.
</span>
          </details>
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Bagaimana dengan Nomor Induk Sekolah Nasional murid di Sekolah Megana ? 
</summary>
<span className="p-5">
    Seluruh murid yang sejak awal bersekolah penuh di Sekolah Megana akan memperoleh NISN yang diurus langsung oleh Sekolah Megana. Sedangkan untuk NISN murid yang juga bersekolah di tempat lain (double school), maka kepengurusan NISN-nya akan tetap diserahkan kepada sekolah induk / sekolah awal murid. Murid pindahan untuk bersekolah penuh di Sekolah Megana dibantu proses administrasi perpindah-alihan kepengurusan NISN-nya oleh Sekolah Megana.
</span>
          </details>
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Bagaimana pelaksanaan teknis pertemuan luar jaringan (Tatap Muka)? 
</summary>
<span className="p-5">
    Sekolah Megana siap mengadakan pembelajaran tatap muka di berbagai daerah dengan partner guru dan lembaga pendidikan yang tersebar di seluruh Indonesia. Materi dan kurikulum dijamin terus kualitasnya oleh tim Sekolah Megana Pusat. Partner Sekolah Megana di daerah juga menyesuaikan dengan konteks lokal supaya pembelajaran tepat sasaran. Selama kondisi pandemi, Sekolah Megana selalu memastikan untuk mematuhi dan menjalankan protokol kesehatan secara ketat dalam pelaksanaan pembelajaran luringnya.
</span>
          </details>
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Bagaimana teknis pengajaran online ?
</summary>
<span className="p-5">
    Untuk pengajaran online materi setara SMA kurikulum Kemdikbud, Sekolah Megana menetapkan private mentoring, yakni 1 mentor untuk 1 siswa sehingga siswa benar-benar dibimbing menguasai pelajaran Matematika, Fisika, Kimia, BIologi  (jurusan IPA) atau Matematika, Sosiologi, Ekonomi, Geografi (jurusan IPS) serta kemampuan Berbahasa Indonesia dan Pendidikan Kewarganegaraan (Civic) sehingga memenuhi Standar Asesmen Kompetensi Minimum Kemdikbud.<br /><br />Sedangkan untuk materi IELTS (English), HSK (Mandarin), dan Ujian Standar Internasional (A Level/SAT/ACT/IB) (English), dilaksanakan secara online dengan sistem kelas yang tersistem dengan pembimbing yang sudah terakreditasi dan berpengalaman. 
</span>
          </details>
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Apa jaminan bahwa lulusan Sekolah Megana akan mendapat Ijazah dari Kemdikbud? 
</summary>
<span className="p-5">
    Sekolah Megana sejak Tahun 2010 meluluskan siswa dan semuanya mendapat Ijazah Resmi dari Kemdikbud dan Dinas Pendidikan DKI Jakarta. Bahkan lulusan Sekolah Megana terbukti menembus seleksi Perguruan TInggi Negeri. Di tahun 2020, alumni Sekolah Megana diterima di Universitas Indonesia dan termasuk mahasiswa termuda (baru berusia 16 tahun).
</span>
          </details>
        </div>
        <div className="w-full lg:w-1/2 px-4 py-2">
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Anak saya cepat buyar konsentrasinya sehingga tidak fokus belajar, bagaimana Sekolah Megana mengatasinya secara pembelajaran online?
</summary>
<span className="p-5">
    Sekolah Megana sejak Tahun 2010 sudah melaksanakan pembelajaran online karena siswanya berada di Hawaii Amerika Serikat sampai Tarakan Kalimantan Timur.  Pengalaman lebih 10 tahun untuk  melaksanakan pembelajaran online, maka metode belajar mengajar Sekolah Megana adalah private mentoring 1 on 1, yakni 1 mentor mengajar 1 siswa. Siswa boleh memilih pelajaran yang akan dibahas dan cara online menggunakan professional video meeting platform sehingga siswa bisa membahas pelajaran bersama mentor pelajaran pilihannya dengan nyaman dan private. 
</span>
          </details>
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Bagaimana caranya agar anak saya benar-benar mendapat beasiswa untuk kuliah internasional? Apa jaminan dari Sekolah Megana? 
</summary>
<span className="p-5">
    Beasiswa sangat ditentukan oleh kemampuan siswa sendiri. Namun harap dicatat, alumni Sekolah Megana sudah membuktikan berhasil meraih beasiswa nasional dan  internasional. Untuk meraih beasiswa diperlukan persiapan yang sangat matang. Oleh karena itulah, selama tiga tahun semasa SMA, Sekolah Megana mempersiapkan siswa;  materi wajib Kurikulum Kemdikbud untuk Ijazah Negara,  pelatihan ujian IELTS (Bahasa Inggris) dan Ujian Standar Internasional (A Level/SAT/ACT/IB) yang merupakan ujian standar kemampuan kritis untuk para calon mahasiswa di AS, China, Singapura, dll.  <br /><br />Karena sasaran utama Sekolah Megana adalah Beasiswa China Government Scholarship, maka selama 3 tahun penuh, siswa akan diberikan pembelajaran HSK (汉语水平考试 - Hànyǔ Shuǐpíng Kǎoshì) oleh mentor yang merupakan alumni Sekolah dan Universitas Bahasa Mandarin di Beijing dan Shanghai. 
</span>
          </details>
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Bagaimana proses seleksi siswa agar bisa terpilih masuk ke Sekolah Megana?
</summary>
<span className="p-5">
    Sekolah Megana menerapkan tes seleksi masuk berupa Tes Minat Bakat yaitu tes dimana SM akan melihat preferensi cara belajar, minat, bakat, serta tujuan studi anak. <br /><br />Seleksi ini akan menjadi pertimbangan Sekolah Megana dalam memberikan bimbingan bimbingan yang sesuai dengan masing-masing anak untuk dapat masuk ke PTN.
</span>
          </details>
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Apakah ada Pilihan Jurusan di Sekolah Megana untuk Persiapan Siswa Tembus PTN?
</summary>
<span className="p-5">
    Tentu, ada. Sekolah Megana menyediakan 2 Jurusan bagi Peserta Didik yaitu Jurusan SMA IPA dan SMA IPS. <br /><br />Selain itu, Sekolah Megana juga memberikan layanan Bimbingan Intensif bagi seluruh siswa sehingga dapat 100% Tembus PTN Impian.
</span>
          </details>
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
    Sebesar apa biaya yang harus dipersiapkan orangtua untuk anak dapat  SMA di Sekolah Megana yang fokus membimbing siswa tembus PTN Impian?
</summary>
<span className="p-5">
    Untuk mendapatkan fasilitas SMA Fokus Persiapan Tembus PTN, orangtua hanya perlu mempersiapkan biaya setara dengan SMA biasa yaitu Uang Pangkal Rp 15 Juta untuk SMA selama 3 tahun dan SPP Rp 1,5 juta/bulan.<br /><br />Biaya tersebut sudah mencakup layanan materi pembelajaran online, materi pembelajaran tatap muka, bimbingan intensif masuk PTN, Mentor, serta konsultasi anak dan orangtua selama 3 tahun sekolah.
</span>
          </details>
          <details className="mb-4">
            <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4 mb-3">
            Bagaimana proses seleksi siswa agar bisa terpilih masuk ke Sekolah Megana?
</summary>
<span className="p-5">
Sekolah Megana menerapkan tes seleksi masuk berupa Tes Minat Bakat yaitu tes dimana SM akan melihat preferensi cara belajar, minat, bakat, serta tujuan studi anak. 
<br /><br />
Seleksi ini akan menjadi pertimbangan Sekolah Megana dalam memberikan bimbingan bimbingan yang sesuai dengan masing-masing anak untuk dapat masuk ke PTN.
</span>
          </details>
        </div>
      </div>
    </div>
  </section>
</div>


  );
};

export default Content;
